// polled, not pushed; a few minutes of staleness is fine for this dashboard
export const ACTIVITY_REFRESH_INTERVAL_MS = 60000;

// A background refresh replaces the list wholesale, so it has to re-request every
// page the user has paged in as a single window - which grows with the page count.
// Past this many rows the poll stands down rather than send a window the endpoint
// would silently truncate: parseLimit in agamotto-organization-lambda-ms clamps
// limit to MAX_LIMIT, so a wider ask comes back short and the refresh would drop
// rows off the bottom of what the user had loaded. Keep this equal to that cap.
export const ACTIVITY_MAX_REFRESH_ROWS = 200;

// must match MIN_INTERVAL_MINUTES / MAX_INTERVAL_MINUTES in agamotto-organization-lambda-ms utils/alertSettings.ts
export const ACTIVITY_ALERT_MIN_INTERVAL_MINUTES = 1;
export const ACTIVITY_ALERT_MAX_INTERVAL_MINUTES = 10080;
